import cssModule from "@vercel/turbopack-next/internal/font/local/cssmodule.module.css?{%22path%22:%22_app.js%22,%22import%22:%22%22,%22arguments%22:[{%22src%22:[{%22path%22:%22../fonts/Switzer-Variable.woff2%22,%22weight%22:%22100%20900%22,%22style%22:%22normal%22},{%22path%22:%22../fonts/Switzer-VariableItalic.woff2%22,%22weight%22:%22100%20900%22,%22style%22:%22italic%22}],%22variable%22:%22--font-switzer%22,%22display%22:%22swap%22}],%22variableName%22:%22switzer%22}";
const fontData = {
    className: cssModule.className,
    style: {
        fontFamily: "'switzer', 'switzer Fallback'",
        
    },
};

if (cssModule.variable != null) {
    fontData.variable = cssModule.variable;
}

export default fontData;
